import { useState } from 'react';
import { IconArchive, IconClock, IconTrash } from '@tabler/icons-react';
import { NotificationStatus } from '@next-is-free-monorepo/next-is-free-types';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem, Button } from '@virlewood/board-79';
import { toast } from 'sonner';
import { apiV1 } from '../../utils/apiClient';
import NotificationScheduleModal from './NotificationScheduleModal';
import dayjs, { Dayjs } from 'dayjs';
import CModal from '../CModal';
import { NActionIcon } from '@next-is-free-monorepo/nif-web-components';
import { MoreHorizontalIcon } from '@hugeicons/core-free-icons';

const NotificationOptionBtn = ({ status, notificationId, setSelectedNotificationId }: {
  status: NotificationStatus,
  notificationId: string,
  setSelectedNotificationId: (id: undefined) => void
}) => {

  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [confirmArchive, setConfirmArchive] = useState(false);

  const queryClient = useQueryClient();

  const archive = {
    mutationKey: ['notification', 'archive'],
    mutationFn: async () => await apiV1.put(`/shop/notifications/${notificationId}/archive`, {}),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['get', '/shop/notifications'] });
      setConfirmArchive(false);
      toast.success('Notifica archiviata');
    }
  };

  const deleteNotification = {
    mutationKey: ['notification', 'delete'],
    mutationFn: async () => await apiV1.delete(`/shop/notifications/${notificationId}`, {}),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['get', '/shop/notifications'] });
      setConfirmDelete(false);
      setSelectedNotificationId(undefined);
      toast.success('Notifica eliminata');
    }
  };

  const rescheduleNotification = useMutation({
    mutationKey: ['notification', 'reschedule'],
    mutationFn: async (schedule_time: Dayjs) => await apiV1.put(`/shop/notifications/${notificationId}`, { schedule_time: schedule_time.toISOString() }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['get', '/shop/notifications'] });
      setScheduleModalOpen(false);
    }
  });

  return (
    <>
      <NotificationScheduleModal open={scheduleModalOpen} onSubmit={rescheduleNotification.mutate}
                                 loading={rescheduleNotification.isPending} onCancel={() => setScheduleModalOpen(false)}
                                 defaultValue={dayjs()} />
      <DropdownMenu>
        <DropdownMenuTrigger asChild disabled={status === 'archived'}>
          <Button iconOnly variant={'outline'} size={'sm'} className={'rounded-full'}
                  startIcon={'hugeicons:more-horizontal'} />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          {status === 'pending' ? (
            <>
              <DropdownMenuItem onSelect={() => setScheduleModalOpen(true)}>
                <IconClock size={16} />
                Riprogramma
              </DropdownMenuItem>
              <DropdownMenuItem variant="destructive" onSelect={() => setConfirmDelete(true)}>
                <IconTrash size={16} />
                Elimina
              </DropdownMenuItem>
            </>
          ) : (
            <DropdownMenuItem onSelect={() => setConfirmArchive(true)}>
              <IconArchive size={16} />
              Archivia
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      <CModal color={'red'} mutationOptions={deleteNotification} title={'Vuoi davvero eliminare questa notifica?'}
              text={'questa azione è irreversibile'} open={confirmDelete} onClose={() => setConfirmDelete(false)}
              icon={<IconTrash />} />
      <CModal color={'black'} mutationOptions={archive} title={'Vuoi davvero archiviare questa notifica?'}
              text={'La notifica non sarà più visibile. Questa azione è irreversibile'} open={confirmArchive}
              onClose={() => setConfirmArchive(false)}
              icon={<IconArchive />} />
    </>
  );
};
export default NotificationOptionBtn;
